<f-data-card>
  <div class="container privacy-policy">

    <!-- Header -->
    <div class="row">
      <div class="col-md-6 col-lg-6 privacy-policy-header">
        <h5>Privacy Policy</h5>
      </div>
    </div>

    <!-- Information banner — always visible -->
   <section class="error-wrapper">
        <f-alert variant="info">
          {{ privacyPolicyInfoBanner }}
        </f-alert>
   </section>

    <!-- Error banner -->
    <section class="error-wrapper" *ngIf="policyData.sendFailure">

        <f-alert variant="error">{{ privacyPolicySendFailure }}
        </f-alert>
    </section>

    <div class="row main-content">

      <!-- ===== LEFT PANEL: Delivery Method ===== -->
      <div class="col-md-12 col-lg-6 privacy-policy-left">
        <div class="card-row">
          <h6 class="delivery-heading">Choose a delivery method:</h6>

          <section class="radio-selection" id="mobileNumbersSection">
            <mat-radio-group color="primary"
                             class="account-selection custom-radio-selection"
                             disableRipple
                             aria-label="Select a delivery method"
                             [(ngModel)]="policyData.defaultSelectedValue"
                             (change)="onDeliveryMethodChange($event.value)">

              <!-- Text / Mobile -->
              <p class="privacy-content-heading"><strong>Text</strong></p>

              <ng-container *ngIf="policyData.mobileNumbers.length > 0">
                <mat-radio-button *ngFor="let phone of policyData.mobileNumbers"
                                  [value]="phone">
                  <b>{{ phone.countryCode }} </b>{{ phone.phoneNumber }}
                </mat-radio-button>
              </ng-container>

              <mat-radio-button [value]="customMobileOption"
                                (click)="onCustomMobileRadioClick($event)"
                                (focusin)="onCustomMobileFocus()">
                <f-intl-tel-input [defaultCountry]="policyData.countryCode || 'US'"
                                  [hideDropdown]="!!policyData.customMobileNumber"
                                  language="en-US"
                                  mandatory-country-code="true"
                                  label-text=""
                                  helper-text=""
                                  appAutoCompleteOff
                                  class="clear-input"
                                  [disabled]="policyData.isEmailSelected ||
                                              policyData.isMobileSelected ||
                                              policyData.isCustomEmailSelected"
                                  (telInputChanged)="onTelInputChange($event)">
                </f-intl-tel-input>
              </mat-radio-button>

              <!-- Email -->
              <p class="privacy-content-heading"><strong>Email</strong></p>

              <ng-container *ngIf="policyData.emails.length > 0">
                <mat-radio-button *ngFor="let emailEntry of policyData.emails"
                                  [value]="emailEntry">
                  {{ emailEntry.emailAdress }}
                </mat-radio-button>
              </ng-container>

              <mat-radio-button class="custom-radio-width" [value]="customEmailOption">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Email address</mat-label>
                  <input matInput
                         type="email"
                         name="customEmail"
                         #emailInput="ngModel"
                         email
                         appAutoCompleteOff
                         [(ngModel)]="policyData.customEmail"
                         (focus)="onCustomEmailFocus()"
                         (input)="onCustomEmailInput()"
                         [disabled]="policyData.mobileNumber.length > 0 ||
                                     policyData.isEmailSelected ||
                                     policyData.isMobileSelected ||
                                     policyData.isCustomMobileSelected"
                         [pattern]="emailPattern" />
                  <mat-error *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
                    Invalid email address.
                  </mat-error>
                </mat-form-field>
              </mat-radio-button>

            </mat-radio-group>
          </section>
        </div>
      </div>

      <!-- ===== RIGHT PANEL: Language ===== -->
      <div class="col-md-12 col-lg-6 privacy-policy-right"
           [formGroup]="languageForm">
        <div class="card-row">
          <h6 class="delivery-heading">Choose language:</h6>
          <p class="privacy-content-heading">Select a language for the Privacy Policy message:</p>
          <section class="radio-selection">
            <mat-radio-group color="primary"
                             class="account-selection custom-radio-selection"
                             disableRipple
                             formControlName="language"
                             aria-label="Select a language"
                             [class.section-disabled]="languageForm.get('language')?.disabled">
              <mat-radio-button *ngFor="let lang of languages"
                                [value]="lang.value"
                                [disabled]="languageForm.get('language')?.disabled">
                {{ lang.label }}
              </mat-radio-button>
            </mat-radio-group>
          </section>
        </div>
      </div>

    </div>

    <!-- Action buttons -->
    <div class="btn-refresh-container flex">
      <div class="btn-controls">
        <f-button text="Send" title="Send" type="button" variant="progressive"
                  [disabled]="!isSendEnabled()"
                  (click)="sendPcsNotification()">
        </f-button>
      </div>
    </div>

  </div>
</f-data-card>
